<template>
  <sj-layout-menu>
    <template v-if="auth&&auth.me">
      <el-menu-item index="/">
        <i class="el-icon-s-home"></i>
        <span slot="title">主页</span>
      </el-menu-item>

      <el-menu-item index="/document/preview">
        <i class="el-icon-document"></i>
        <span slot="title">立即尝试</span>
      </el-menu-item>

      <el-menu-item index="/document">
        <i class="el-icon-tickets"></i>
        <span slot="title">调用明细</span>
      </el-menu-item>

      <el-submenu index="/user">
        <template slot="title">
          <i class="el-icon-key"></i>
          <span class="menu-text">AccessKey管理</span>
        </template>
        <el-menu-item index="/access-key/table">AccessKey列表</el-menu-item>
      </el-submenu>

      <el-submenu v-if="$model.auth.isAdmin()" index="/user">
        <template slot="title">
          <i class="el-icon-user-solid"></i>
          <span class="menu-text">用户管理</span>
        </template>
        <el-menu-item index="/user/table">用户列表</el-menu-item>
        <el-menu-item index="/user/create">创建用户</el-menu-item>
      </el-submenu>
    </template>
    <template v-else>
      <el-menu-item index="/document/try">
        <i class="el-icon-document"></i>
        <span slot="title">立即尝试</span>
      </el-menu-item>
    </template>
  </sj-layout-menu>
</template>

<script>
export default {
  name: 'DefaultLayoutMenus',
  components: {},
  data () {
    return {
      auth: auth
    }
  },
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style lang="scss"></style>
